import { useQuery } from '@tanstack/react-query';
import { fetchQuestionBankSubjects } from '../services/questionBankSubjectService';
import { fetchExamSubjects } from '../services/examCategoryService';

export function useQuestionBankSubjects(params = {}, options = {}) {
  const { examFlow = false, ...queryOptions } = options;
  return useQuery({
    queryKey: ['questionBankSubjects', examFlow, params],
    queryFn: async () => {
      const payload = examFlow
        ? await fetchExamSubjects(params)
        : (await fetchQuestionBankSubjects(params)).payload;

      return {
        subjectList: Array.isArray(payload?.subject_list) ? payload.subject_list : [],
        pagination: payload?.pagination || {},
        topicVisibilityStatus: Number(payload?.topic_visibility_status || 0),
        topicToggleStatus: Number(payload?.topic_toggle_status || 0),
        bannerImage: payload?.banner_image || '',
        categoryId: Number(payload?.category_id || params?.category_id || 0),
        stateName: payload?.state_name || '',
        categoryName: payload?.category_name || '',
        userCoins: Number(payload?.user_coins || 0),
        todayTotalAttempts: Number(payload?.today_total_attempts || 0),
        todayTotalAttemptsLeft: Number(payload?.today_total_attempts_left || 0),
        backgroundColorCode: payload?.background_color_code || '',
        borderColorCode: payload?.border_color_code || '',
        isSubscribed: Number(payload?.is_subscribed || 0) === 1,
      };
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        subjectList: [],
        pagination: {},
        topicVisibilityStatus: 0,
        topicToggleStatus: 0,
        bannerImage: '',
        categoryId: Number(params?.category_id || 0),
        stateName: '',
        categoryName: '',
        userCoins: 0,
        todayTotalAttempts: 0,
        todayTotalAttemptsLeft: 0,
        backgroundColorCode: '',
        borderColorCode: '',
        isSubscribed: false,
      },
    ...queryOptions,
  });
}
